import { atom } from 'jotai';
import { domain } from 'modules/data';

export const schedulerRadioCheckedState = atom<domain.ScheduleMonthType>(domain.ScheduleMonthType.EveryMonth);
